import React from 'react';
import { useParams } from 'react-router-dom';

interface ComponentProps {
  Route: React.FC;
  paramKey: string;
  [key: string]: any;
}

const AppDynamicRoute: React.FC<ComponentProps> = ({ Route, paramKey, ...props }) => {
  const params = useParams();
  return <Route key={params[paramKey]} {...props} />;
};

export default AppDynamicRoute;
